export default __webpack_public_path__ + "static/media/InsideBlood_05.9ec88e2d.png";